import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type ActiveOrganizationId = string | null;

type ActiveOrganizationState = {
	organizationId: ActiveOrganizationId;
	getOrganizationId: () => ActiveOrganizationId;
	setOrganizationId: (organizationId: ActiveOrganizationId) => void;
};

export const useActiveOrganizationStore = create<ActiveOrganizationState>()(
	persist(
		(set, get): ActiveOrganizationState => ({
			organizationId: null,
			getOrganizationId: (): ActiveOrganizationId => get().organizationId,
			setOrganizationId: (organizationId: ActiveOrganizationId): void => {
				set({ organizationId });
			},
		}),
		{
			name: "active-organization-id",
			storage: createJSONStorage(() => localStorage),
		}
	)
);

export const getActiveOrganizationId = (): ActiveOrganizationId => useActiveOrganizationStore.getState().getOrganizationId();

export const setActiveOrganizationId = (organizationId: ActiveOrganizationId): void => {
	useActiveOrganizationStore.getState().setOrganizationId(organizationId);
};
